import CustomButton from 'components/Buttons/CustomButton'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Col, FormGroup, Input, Modal, ModalBody, Row } from 'reactstrap'
import { toggleModal } from './reportAttendanceSlice'
import {
  formatDateOnlyPMB,
  formatDateOnlyPMBV1,
  formatTimeOnlyPMB,
} from 'utils/formatDate'
import { Clock } from 'react-feather'
import Flatpickr from 'react-flatpickr'
import { useSnackbar } from 'notistack'
import { editAttendance } from './reportAttendanceAction'
import { P } from 'components'

const ModalEditAttendance = ({ row, refetch }) => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { isOpenModal } = useSelector((s) => s.reportAttendance)
  const toggle = () => dispatch(toggleModal())
  const [payload, setPayload] = useState(null)
  const [loading, setLoading] = useState(false)

  const parsedNotes =
    typeof row?.notes === 'string' ? JSON.parse(row.notes) : row?.notes || []

  const parsedNotesEditor = !row?.editorNotes
    ? []
    : typeof row.editorNotes === 'string'
      ? JSON.parse(row.editorNotes)
      : Array.isArray(row.editorNotes)
        ? row.editorNotes
        : []

  const onSubmitEdit = async () => {
    setLoading(true)
    dispatch(editAttendance({ obj: payload, id: row?.id }))
      .then((res) => {
        if (res?.error?.message) {
          throw res?.payload?.data?.message || res?.error?.message
        }

        toggle()
        refetch()
        enqueueSnackbar('Berhasil edit data absensi.', {
          variant: 'success',
        })
        setLoading(false)
      })
      .catch((err) => {
        enqueueSnackbar(err, {
          variant: 'error',
        })
        setLoading(false)
      })
  }

  useEffect(() => {
    if (!isOpenModal) {
      setPayload(null)
    }
  }, [isOpenModal])

  return (
    <>
      <Modal centered isOpen={isOpenModal} toggle={toggle} data-testid="attendance-report-modal-edit">
        <ModalBody>
          <P
            className="text-sm pb-3 fw-semibold"
            size="medium"
            color="#101828"
            bold
          >
            Edit Absensi
          </P>
          <FormGroup>
            <P
              className="text-sm pb-1 fw-semibold"
              size="regular"
              color="#344054"
            >
              Nama
            </P>
            <small>{row?.verifiedprofile?.name}</small>
          </FormGroup>

          <FormGroup>
            <P
              className="text-sm pb-1 fw-semibold"
              size="regular"
              color="#344054"
            >
              Tanggal
            </P>
            <small>{formatDateOnlyPMBV1(row?.createdAt)}</small>
          </FormGroup>

          <FormGroup>
            <P
              className="text-sm pb-1 fw-semibold"
              size="regular"
              color="#344054"
            >
              Check In
            </P>
            <div
              className="d-flex align-items-center justify-content-center border rounded"
              style={{
                padding: '2px 6px',
              }}
            >
              <Clock size={17} className="ms-3" />
              <Flatpickr
                defaultValue={row?.checkIn ? [row.checkIn] : []}
                options={{
                  enableTime: true,
                  dateFormat: 'Y-m-d H:i',
                  onClose: (selectedDates) => {
                    if (!selectedDates[0]) return

                    const selected = new Date(selectedDates[0])

                    const baseDate = row?.checkIn
                      ? new Date(row.checkIn)
                      : new Date(selected)

                    const updatedDateTime = new Date(baseDate)
                    updatedDateTime.setHours(selected.getHours())
                    updatedDateTime.setMinutes(selected.getMinutes())
                    updatedDateTime.setSeconds(0)
                    updatedDateTime.setMilliseconds(0)

                    setPayload((prev) => ({
                      ...prev,
                      checkIn: updatedDateTime.toISOString(),
                    }))
                  },
                }}
                className="form-control flat-picker bg-transparent border-0 shadow-none"
              />
            </div>
          </FormGroup>

          <FormGroup>
            <P
              className="text-sm pb-1 fw-semibold"
              size="regular"
              color="#344054"
            >
              Check Out
            </P>
            <div
              className="d-flex align-items-center justify-content-center border rounded"
              style={{
                padding: '2px 6px',
              }}
            >
              <Clock size={17} className="ms-3" />
              <Flatpickr
                defaultValue={row?.checkOut ? [row.checkOut] : []}
                options={{
                  enableTime: true,
                  dateFormat: 'Y-m-d H:i',
                  onClose: (selectedDates) => {
                    if (!selectedDates[0]) return

                    const selected = new Date(selectedDates[0])

                    const baseDate = row?.checkOut
                      ? new Date(row.checkOut)
                      : new Date(selected)

                    const updatedDateTime = new Date(baseDate)
                    updatedDateTime.setHours(selected.getHours())
                    updatedDateTime.setMinutes(selected.getMinutes())
                    updatedDateTime.setSeconds(0)
                    updatedDateTime.setMilliseconds(0)

                    setPayload((prev) => ({
                      ...prev,
                      checkOut: updatedDateTime.toISOString(),
                    }))
                  },
                }}
                className="form-control flat-picker bg-transparent border-0 shadow-none"
              />
            </div>
          </FormGroup>

          <FormGroup>
            <P
              className="text-sm pb-1 fw-semibold"
              size="regular"
              color="#344054"
            >
              Catatan
            </P>
            <div className="d-flex flex-column gap-2 py-1">
              {parsedNotes?.length > 0
                ? parsedNotes.map((e, i) => (
                    <div className="d-flex flex-column" key={i}>
                      <small className="text-break">
                        {formatDateOnlyPMB(e?.ts)}
                      </small>
                      <small className="text-break">{e?.notes}</small>
                    </div>
                  ))
                : '-'}
            </div>
          </FormGroup>

          <FormGroup>
            <P
              className="text-sm pb-1 fw-semibold"
              size="regular"
              color="#344054"
            >
              Catatan Editor
            </P>
            <div className="d-flex flex-column gap-2 py-1">
              {parsedNotesEditor.map((e, i) => (
                <div className="d-flex flex-column" key={i}>
                  <small className="text-break">
                    {formatDateOnlyPMB(e?.ts)}
                  </small>
                  <small className="text-break">{e?.notes}</small>
                </div>
              ))}
            </div>

            <Input
              placeholder="Masukkan catatan baru"
              name="editorNotes"
              value={payload?.editorNotes ?? null}
              type="textarea"
              onChange={(e) => {
                setPayload((prev) => ({
                  ...prev,
                  editorNotes: e?.target?.value,
                }))
              }}
              data-testid="attendance-report-modal-edit-editor-notes"
            />
          </FormGroup>

          <div className="d-flex justify-content-between gap-2">
            <CustomButton
              className="btn-cancel"
              size="sm"
              onClick={toggle}
              block
              disabled={loading}
              testId="attendance-report-modal-edit-cancel-button"
            >
              Batal
            </CustomButton>
            <CustomButton
              color="primary"
              size="sm"
              onClick={onSubmitEdit}
              block
              disabled={loading || !payload}
              testId="attendance-report-modal-edit-submit-button"
            >
              Perbarui
            </CustomButton>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ModalEditAttendance
